import AppConstants from '../config/app.constants';

let LockOpenErrorService = function ($http, $q) {

    let getFailedToOpenLocks = (branchId, startDate, endDate) => {
        return $http
            .get(AppConstants.api + `/lock-open-errors/get-failed-to-open-locks`, {
                params: {
                    branchId,
                    startDate,
                    endDate
                }
            })
            .then((res) => {
                return res.data;
            })
    }

    let exportFailedToOpenLock = (branchId, startDate, endDate) => {
        return $http
            .post(AppConstants.api + `/lock-open-errors/export-failed-to-open-locks`, { branchId, startDate, endDate })
            .then((res) => {
                return res.data;
            })
    }

    return {
        getFailedToOpenLocks,
        exportFailedToOpenLock
    };
}

LockOpenErrorService.$inject = ['$http', '$q'];

export default LockOpenErrorService;


// WEBPACK FOOTER //
// ./client/app/services/lock-open-errors.service.js